import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Booking from "./pages/Booking";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Reviews from "./pages/Reviews";
import Pricing from "./pages/Pricing";
import DriverLogin from "./pages/DriverLogin";
import DriverDashboard from "./pages/DriverDashboard";

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <BrowserRouter>
        {/* Driver routes don't need header/footer */}
        <Routes>
          <Route path="/driver-login" element={<DriverLogin />} />
          <Route path="/driver-dashboard" element={
            <ProtectedRoute>
              <DriverDashboard />
            </ProtectedRoute>
          } />
          
          {/* Regular pages with header/footer */}
          <Route path="/*" element={
            <>
              <Header />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/services" element={<Services />} />
                <Route path="/pricing" element={<Pricing />} />
                <Route path="/booking" element={<Booking />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/reviews" element={<Reviews />} />
              </Routes>
              <Footer />
            </>
          } />
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  </AuthProvider>
  );
}

export default App;
